import { createTypes, createActions, createReducer } from './util'
import _ from 'lodash/fp'

const namespace = 'connectedUnions'

const typeKeys = [
  'CONNECT_REQUEST',
  'CONNECT_SUCCESS',
  'CONNECT_ERROR',

  'DISCONNECT_REQUEST',
  'DISCONNECT_SUCCESS',
  'DISCONNECT_ERROR',

  'SUBMIT_REQUEST',
  'SUBMIT_ERROR',
  'SUBMIT_SUCCESS',

  'SYNC_USER_INFO_REQUEST',
  'SYNC_USER_INFO_ERROR',
  'SYNC_USER_INFO_SUCCESS',

  'GET_ORGANIZATIONS_REQUEST',
  'GET_ORGANIZATIONS_ERROR',
  'GET_ORGANIZATIONS_SUCCESS',

  'TOGGLE_MODAL',
  'SET_TOAST'
]

export const types = createTypes(typeKeys, namespace)

export const actions = createActions(types)

function createSelectors () {
  const connecting = _.get(`${namespace}.connecting`)
  const connected = _.get(`${namespace}.connected`)
  const synced = _.get(`${namespace}.synced`)
  const connectError = _.get(`${namespace}.connectError`)
  const disconnecting = _.get(`${namespace}.disconnecting`)
  const disconnectError = _.get(`${namespace}.disconnectError`)
  const syncing = _.get(`${namespace}.syncing`)
  const syncError = _.get(`${namespace}.syncError`)
  const submitting = _.get(`${namespace}.submitting`)
  const submitError = _.get(`${namespace}.submitError`)
  const modalVisible = _.get(`${namespace}.modalVisible`)
  const organizations = _.flow(_.get(`${namespace}.organizations`), _.sortBy('name'))
  const toast = _.flow(_.get(`${namespace}.toast`))

  return {
    connecting,
    connected,
    synced,
    connectError,
    disconnecting,
    disconnectError,
    syncing,
    syncError,
    submitting,
    submitError,
    modalVisible,
    organizations,
    toast
  }
}

export const selectors = createSelectors()

const initialState = {
  toast: {},
  connecting: false,
  connected: undefined,
  synced: undefined,
  connectError: false,
  syncing: false,
  syncError: false,
  submitting: false,
  submitError: false,
  modalVisible: false,
  gettingOrganizations: false,
  organizations: undefined
}

const reducer = {
  [types.CONNECT_REQUEST]: () => _.set('connecting', true),
  [types.CONNECT_SUCCESS]: unionName => _.flow(
    _.set('connecting', false),
    _.set('connectError', false),
    _.set('connected', Date.now())
  ),
  [types.CONNECT_ERROR]: error => _.flow(
    _.set('connecting', false),
    _.set('connectError', error)
  ),
  [types.DISCONNECT_REQUEST]: () => _.set('disconnecting', true),
  [types.DISCONNECT_SUCCESS]: unionName => _.flow(
    _.set('disconnecting', false),
    _.set('disconnectError', false)
  ),
  [types.DISCONNECT_ERROR]: error => _.flow(
    _.set('disconnecting', false),
    _.set('disconnectError', error)
  ),
  [types.SYNC_USER_INFO_REQUEST]: () => _.set('syncing', true),
  [types.SYNC_USER_INFO_SUCCESS]: unionName => _.flow(
    _.set('syncing', false),
    _.set('syncError', false),
    _.set('synced', Date.now())
  ),
  [types.SYNC_USER_INFO_ERROR]: error => _.flow(
    _.set('syncing', false),
    _.set('syncError', error)
  ),
  [types.SUBMIT_REQUEST]: p => _.set('submitting', _.get('union', p)),
  [types.SUBMIT_ERROR]: error => _.flow(
    _.set('submitError', error),
    _.set('submitting', false)
  ),
  [types.SUBMIT_SUCCESS]: p => _.flow(
    _.set('submitting', false),
    _.set('submitError', false)
  ),
  [types.GET_ORGANIZATIONS_REQUEST]: p => _.flow(
    _.set('gettingOrganizations', true),
    _.set('getOrganizationsError', false)
  ),
  [types.GET_ORGANIZATIONS_SUCCESS]: p => _.flow(
    _.set('gettingOrganizations', false),
    _.set('organizations', p)
  ),
  [types.GET_ORGANIZATIONS_ERROR]: p => _.flow(
    _.set('gettingOrganizations', false),
    _.set('getOrganizationsError', p)
  ),
  [types.TOGGLE_MODAL]: p => _.update('modalVisible', b => !b),
  [types.SET_TOAST]: p => _.set('toast', p)
}

export default createReducer(initialState, reducer)
